"use strict";
module.exports = {
    entityModel: 'alert',
    events: {
        ALERT_CLOSED: 'ALERT_CLOSED',
        ALERT_UPDATED: 'ALERT_UPDATED',
        ALERT_CREATED: 'ALERT_CREATED',
    },
    actions: {
        get: 'v1.alert.get',
        list: 'v1.alert.list',
        raiseAlert: 'v1.alert.raiseAlert',
        closeAlert: 'v1.alert.closeAlert',
        upsert: 'v1.alert.upsert',
        upsertWhenEmpty: 'v1.alert.upsertWhenEmpty',
        updateWhenEmpty: 'v1.alert.updateWhenEmpty',
        update: 'v1.alert.update',
    },
    colors: {
        danger: 'danger',
        warning: 'warning',
        success: 'success',
        info: 'info',
        primary: 'primary',
        secondary: 'secondary',
    },
};
